exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dt[data-v-1606e6be], dd[data-v-1606e6be] {\n  margin-bottom: 20px;\n  display: inline-block;\n  vertical-align: middle;\n}\ndt[data-v-1606e6be] {\n  min-width: 100px;\n  width: 30%;\n}\ndd[data-v-1606e6be] {\n  width: 60%;\n}\n", ""]);
